//直播公开课
const teacherDetail = () => import('@/pages/courseDetail/teacherDetail.vue');
const vipTeacherDetail = () => import('@/pages/courseDetail/vipTeacherDetail.vue');
export default [
  {
    path: '/teacherDetail',
    component: teacherDetail,
    meta: {
      title: '教师介绍',
    },
  },
  {
    path: '/vipTeacherDetail',
    component: vipTeacherDetail,
    meta: {
      title: '教师介绍',
    },
  },
  {
    path: '/svipTeacherDetail',
    component: vipTeacherDetail,
    meta: {
      title: '教师介绍',
    },
  },
  {
    path: '/oneToOneTeacherDetail',
    component: vipTeacherDetail,
    meta: {
      title: '教师介绍',
    },
  },

];
